import { notify, type NotifyOptions } from '../../lib/notify';

type PromiseMessages = {
  pending?: string;
  success?: string;
  error?: string;
};

const Notification = {
  showError: (message: string, opts?: NotifyOptions) => notify.error(message, opts),
  showSuccess: (message: string, opts?: NotifyOptions) => notify.success(message, opts),
  showInfo: (message: string, opts?: NotifyOptions) => notify.info(message, opts),
  showWarn: (message: string, opts?: NotifyOptions) => notify.warning(message, opts),
  fromError: (err: unknown, opts?: NotifyOptions & { fallbackTitle?: string }) =>
    notify.fromError(err, opts),

  promise: <T,>(
    promise: Promise<T>,
    { pending = 'Please wait', success = 'Done', error = 'Error' }: PromiseMessages = {}
  ) =>
    notify.promise(promise, {
      loading: pending,
      success,
      error,
    }),

  dismissAll: () => notify.dismiss(),
};

export default Notification;
